import { render, staticRenderFns } from "./ConfigurarLanding.vue?vue&type=template&id=6999c946&"
import script from "./ConfigurarLanding.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarLanding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports